import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Loginscreen from './smallComponents/Loginscreen'
import Signup from './smallComponents/Signup'
import { useNavigate } from 'react-router';
import { setToken, setUserInfo } from '../../features/auth/authSlice'

function Login({ setUserInfo, setToken }) {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken')
    const user = JSON.parse(localStorage.getItem('userInfo'))
    if (token && user) {
      setToken(token);
      setUserInfo(user);
      navigate('/')
    } else {
      navigate('/login')
    }
  }, []);
  return (
    <div
      className="m-auto p-5 w-100"
      style={{ maxWidth: '25rem', height: '100vh' }}
    >
      <div className="d-flex justify-content-center mb-5 flex-column align-items-center">
        <div className="fw-bold fs-2">
          <h1>First Update</h1>
        </div>
      </div>

      <div class="wide-block pb-2">
        <ul class="nav nav-tabs lined" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-bs-toggle="tab"
              href="#example1a"
              role="tab"
            >
              Login
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-bs-toggle="tab"
              href="#example2a"
              role="tab"
            >
              Signup
            </a>
          </li>
        </ul>
        <div class="tab-content mt-2">
          <div class="tab-pane fade show active" id="example1a" role="tabpanel">
            <Loginscreen />
          </div>
          <div class="tab-pane fade" id="example2a" role="tabpanel">
            <Signup />
          </div>
        </div>
      </div>

      {/* <ul class="nav nav-tabs lined" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            data-bs-toggle="tab"
            href="#example1a"
            role="tab"
          >
            <ion-icon name="home"></ion-icon>
            Home
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#example2a" role="tab">
            <ion-icon name="person-circle"></ion-icon>
            Profile
          </a>
        </li>
      </ul>
      <div class="tab-content mt-2">
        <div class="tab-pane fade active show" id="example1a" role="tabpanel">
          <Loginscreen />
        </div>
        <div class="tab-pane fade" id="example2a" role="tabpanel">
          <Signup />
        </div>
      </div> */}
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authToken } = auth

  return {
    authToken
  }
}

const mapDispatchToProps = {
  setToken,
  setUserInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
